module.exports = __webpack_public_path__ + "static/media/yellow@2x.4238e6fe.jpg";